import { AppIcon, RawSVG } from 'core/components/icons/icon.type';

export const iconSearch: AppIcon = {
  svgData: '<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.714 6.838a6.276 6.276 0 1 1-8.876 8.876 6.276 6.276 0 0 1 8.876-8.876M19 19l-3.29-3.29" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' as RawSVG,
  name: 'search',
};
